/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useRef, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import { Formik, Form, Field } from "formik";
import { useMutation, useQuery } from "react-query";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import * as toasts from "../../ECommerce/_redux/toasts/toastsActions";
import { useIntl } from "react-intl";

import {
  Input,
  Select,
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  GET_SECTION_LIST_URL,
  EDIT_SECTION_URL,
  SAVE_SECTION_URL,
  GET_POST_TYPES_URL,
  GET_MEDIA_LIST_URL,
  a_section_url,
} from "../../../../_metronic/_helpers/Constants";
import ProfileService from "../../Profile/service";
import { createSection, editSections } from "../../../_redux/sections/actions";

const EditSchema = Yup.object().shape({
  name: Yup.string().required(),
  type: Yup.string().required(),
  // medij_id: Yup.string().required("media is a required field"),
});

const SectionEditPage = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [currentSection, setCurrentSection] = useState(null);
  const [type, setType] = useState(null);
  const history = useHistory();
  const service = new ProfileService();

  const params = useParams();
  useEffect(() => {
    const fetchSection = async () => {
      if (!params.id) return;
      try {
        const response = await service.post(GET_SECTION_LIST_URL, {
          id: params.id,
          page: 0,
          size: 20,
        });
        const category = response.data.data[0];
        setCurrentSection(category);
        setType(category.type?.id || null);
      } catch (error) {}
    };

    fetchSection();
  }, [params]);

  const saveSection = async (values) => {
    const id = +params.id || null;
    const payload = id ? { ...values, id } : { ...values };
    if (id) {
      dispatch(editSections(payload, intl, toasts, history));
    } else {
      dispatch(createSection(payload, intl, toasts, history));
    }
  };

  const mutation = useMutation(saveSection, {
    onSuccess: (data) => {
      dispatch(
        toasts.showToast(data.status, intl.formatMessage({ id: data.title }))
      );
      dispatch(toasts.hideToast());
    },
    onError: (error) => {
      dispatch(
        toasts.showToast(
          error.response.data.status,
          intl.formatMessage({
            id: error.response.data.details || error.response.data.errors[0],
          })
        )
      );
      dispatch(toasts.hideToast());
    },
  });

  const backToSectionList = () => {
    history.push(a_section_url);
  };
  const btnRef = useRef();

  const saveSectionClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const postTypes = useQuery(
    ["postTypes"],
    async () => (await service.post(GET_POST_TYPES_URL)).data,
    { keepPreviousData: true }
  );

  const mediaTypes = useQuery(
    ["mediaTypes", type],
    async () =>
      (await service.post(GET_MEDIA_LIST_URL, { post_type: type })).data,
    { keepPreviousData: true }
  );

  if (params.id && !currentSection) {
    return null;
  }

  const initialValues = {
    name: currentSection ? currentSection.name : "",
    type: currentSection ? currentSection.type?.id : "",
    // medij_id: currentSection ? currentSection.medij?.id : "",
  };

  const formTitle = params.id
    ? intl.formatMessage({ id: "MENU.OPTIONS.EDIT" }) +
      " " +
      intl.formatMessage({ id: "MENU.SECTION" })
    : intl.formatMessage({ id: "Add_new" }) +
      " " +
      intl.formatMessage({ id: "MENU.SECTION" });

  return (
    <Card>
      <CardHeader title={formTitle}>
        <CardHeaderToolbar>
          <button
            type="button"
            onClick={backToSectionList}
            className="btn btn-light"
          >
            <i className="fa fa-arrow-left"></i>
            {intl.formatMessage({ id: "AUTH.GENERAL.BACK_BUTTON" })}
          </button>
          <button
            type="submit"
            className="btn btn-primary ml-2"
            onClick={saveSectionClick}
          >
            {intl.formatMessage({ id: "MENU.OPTIONS.SAVE" })}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="mt-5">
          <Formik
            initialValues={initialValues}
            validationSchema={EditSchema}
            enableReinitialize
            onSubmit={async (values) => {
              try {
                await mutation.mutateAsync(values);
                history.push(a_section_url);
              } catch (error) {
                console.error(error);
              }
            }}
          >
            {({ handleSubmit, values, setFieldValue, errors }) => (
              <>
                <Form className="form form-label-right">
                  <div className="form-group row">
                    <div className="col-lg-12">
                      <Field
                        type="text"
                        name="name"
                        component={Input}
                        placeholder="Name"
                        label="Name"
                        withFeedbackLabel={false}
                      />

                      {errors.name && (
                        <span className="error">{errors.name}</span>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-lg-12">
                      {!postTypes.isLoading && (
                        <>
                          <Select
                            name="type"
                            id="type"
                            label="Type"
                            withFeedbackLabel={false}
                            onChange={(e) => {
                              setType(+e.target.value || null);
                              setFieldValue("type", +e.target.value || "");
                            }}
                          >
                            <option value="''">Select</option>
                            {postTypes.data.data.map((type) => (
                              <option key={type.id} value={type.id}>
                                {type.name}
                              </option>
                            ))}
                          </Select>
                          {errors.type && (
                            <span className="error">{errors.type}</span>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {/* <div className="form-group row">
                    <div className="col-lg-12">
                      {!mediaTypes.isLoading && (
                        <>
                          <Select
                            name="medij"
                            label="Media"
                            withFeedbackLabel={false}
                            disabled={!type}
                            onChange={(e) => {
                              setFieldValue("medij_id", +e.target.value || "");
                            }}
                          >
                            <option value="''">Select</option>
                            {(type ? mediaTypes.data?.data : []).map(
                              (medij) => (
                                <option key={medij.id} value={medij.id}>
                                  {medij.name}
                                </option>
                              )
                            )}
                          </Select>
                          {errors.medij_id && (
                            <span className="error">{errors.medij_id}</span>
                          )}
                        </>
                      )}
                      {type && !mediaTypes.data?.data.length && (
                        <small className="form-text text-muted">
                          No Media found for selected type.
                        </small>
                      )}
                    </div>
                  </div> */}
                  <button
                    type="submit"
                    style={{ display: "none" }}
                    ref={btnRef}
                    onSubmit={() => handleSubmit()}
                  ></button>
                </Form>
              </>
            )}
          </Formik>
        </div>
      </CardBody>
    </Card>
  );
};

export default SectionEditPage;
